import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Control, Errors } from 'react-redux-form';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { ContractDetailsViewModel } from '@models/Contract';
import { OptionsViewModel } from '@models/common.models';
import { getDefaultErrorMessages, hasValue, hasDateValue } from '@common/validators';
// import { Options } from '@common/components';
import { DynamicSelectIdentifier } from '@common/components/dynamic-select/dynamic-select-types';
import { Select, SpinnerPage } from '@common/components';
import * as classes from './contract-norenew.scss';
import ReactDatePicker from 'react-datepicker';
import * as moment from 'moment-timezone';
import { dateParser } from '@common/dateParser';
import { NoRenewViewModel } from '@models/Contract';
import FormNames from '@constants/FormNames.enum';
import { FormWrapper } from '@common/components/form-wrapper/form-wrapper.component';

export interface ContractNoRenewProperties extends RouteComponentProps<{ id: string }> {
  readonly noRenew: NoRenewViewModel;
  readonly noRenewReasons: Array<OptionsViewModel>;
  readonly contractDetailVM: ContractDetailsViewModel;
  readonly getNoRenewReasons: () => void;
  readonly updateFormNoRenewVM: (noRenewFM: NoRenewViewModel) => void;
  readonly resetForm: () => void;
  readonly noRenewContractSave: (id: number, formValue: NoRenewViewModel) => void;
  readonly removeNoRenew: (id: number) => void;
}

interface ContractNoRenewState {
  isSaving: boolean;
}

export class ContractNoRenewComponent extends React.Component<ContractNoRenewProperties, ContractNoRenewState> {
  // private noRenewVM: NoRenewViewModel;
  private contractId: number;

  constructor(props: ContractNoRenewProperties) {
    super(props);
    this.state = {
      isSaving: false
    };
  }

  componentDidMount() {
    // this.props.resetForm();
    this.contractId = +this.props.match.params.id;
    this.props.getNoRenewReasons();
    if (this.props.noRenew && this.props.noRenew.noRenewCd > 0) {
      this.props.updateFormNoRenewVM(this.props.noRenew);
    } else {
      this.props.resetForm();
    }
    // NOTE: Contract NoRenew Form is initialized in the Forms.ts file in _constants
  }

  handleSubmit = (formValue: NoRenewViewModel) => {
    this.setState({ isSaving: true });
    this.props.noRenewContractSave(this.contractId, formValue);
  };

  handleRemoveNoRenew = () => {
    this.setState({ isSaving: true });
    this.props.removeNoRenew(this.contractId);
  };

  render() {
    if (this.state.isSaving) {
      return <SpinnerPage />;
    }
    return (
      <div className={[classes.contractNoRenew, 'row'].join(' ')}>
        <div className="col-xs-12">
          <FormWrapper
            shouldFormReset={true}
            model={FormNames.NoRenewForm}
            hideNativeErrors={true}
            onSubmit={this.handleSubmit}
          >
            <h2>No-Renew Contract</h2>
            <div className="row mb-10 pb-10">
              <div className="col-lg-6">
                <div className="form-control col-md-12">
                  <label htmlFor="noRenewContractForm.noRenewCd">No-Renew Reason</label>
                  <Select
                    model=".noRenewCd"
                    identifier={DynamicSelectIdentifier.GetNoRenewReasons}
                    validators={{ required: hasValue }}
                  />
                  <Errors
                    className="error error-pad"
                    model=".noRenewCd"
                    show={{ touched: true, focus: false }}
                    messages={getDefaultErrorMessages()}
                  />
                </div>
              </div>
              <div className="row mb-10 pb-10">
                <div className="row">
                  <div className="col-lg-18">
                    <div className="form-control col-md-12 mb-10 pb-10">
                      <label htmlFor="noRenewContractForm.noRenewDate">No-Renew Date</label>
                      <Control
                        model=".noRenewDate"
                        validators={{ hasDateValue: hasDateValue }}
                        component={props => {
                          let val;
                          if (props.value && !moment.isMoment(props.value)) {
                            val = dateParser.parse(props.value);
                          } else {
                            // already a moment
                            val = props.value;
                          }

                          const maxDate =
                            this.props.contractDetailVM && this.props.contractDetailVM.termEnd
                              ? dateParser.parse(this.props.contractDetailVM.termEnd)
                              : null;

                          return (
                            <ReactDatePicker
                              {...props}
                              value={val ? val.format('MM/DD/YYYY') : ''}
                              selected={val || null}
                              maxDate={maxDate}
                            />
                          );
                        }}
                      />
                      <Errors
                        className="error"
                        model="noRenewContractForm.noRenewDate"
                        show={{ touched: true, focus: false }}
                        messages={{ ...getDefaultErrorMessages(), validDate: 'Invalid Date' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="row end-xs text-right">
                <button className="btn btn-primary" type="submit">
                  Submit
                </button>
                <button
                  className="btn btn-primary"
                  onClick={this.handleRemoveNoRenew}
                  hidden={this.props.noRenew.noRenewCd === 0}
                  type="button"
                >
                  Remove No-Renew
                </button>
                <Link
                  className="btn btn-secondary"
                  to={getRoute(RouteDefinitions.contract.Details, { id: this.contractId })}
                >
                  Cancel
                </Link>
              </div>
            </div>
          </FormWrapper>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-norenew/contract-norenew.component.tsx